<template>
  <div class="container">
    <h3 class="title">{{ $t('currency.customOrders') }}</h3>

    <div class="custom-order-content">
      <div class="filters f--c">
        <div class="f--c">
          <el-select v-model="filters.searchType" size="mini" placeholder="Search Brand"  @change="changeDateType" style="width:130px;flex-shrink: 0;">
            <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-date-picker v-model="dateTime" :clearable="true" size="mini" type="daterange" range-separator="~" placement="bottom-start" value-format="timestamp" start-placeholder="Start" end-placeholder="End" class="el-date-picker" @change="e => changeDatePicker(e)" style="width:250px" />
        </div>

        <div>
          <customer-tree-select @change="handleDepartmentTreeChange" />
        </div>
        <el-select v-model="filters.categoryList" multiple collapse-tags size="mini" filterable placeholder="Search Categories" clearable @change="handleSearchInput" style="width:190px;flex-shrink: 0;">
          <el-option
            v-for="item in categoryList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-select v-model="filters.brands" multiple collapse-tags size="mini" filterable placeholder="Search Brand" clearable @change="handleSearchInput" style="width:190px;flex-shrink: 0;">
          <el-option
            v-for="item in brandList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>

        <el-input v-model.trim="filters.searchContent" clearable size="mini" :placeholder="`Enter PO# or Style#`" style="width: 300px;" @change="handleSearchInput">
          <el-button slot="append" icon="el-icon-search" @click="handleSearchInput"></el-button>
        </el-input>
      </div>
      <el-table ref="tableData" :data="list" size="small" height="calc(100vh - 210px)" @selection-change="handleSelectionChange" stripe @sort-change="onTableSortChange" class="table">
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column> -->
        <el-table-column prop="customerPoId" label="PO#" min-width="100" fixed="left"></el-table-column>
        <el-table-column prop="poApplicationDate" label="Order Date" sortable="custom" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.poApplicationDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="client" label="Client" min-width="100"></el-table-column>
        <el-table-column prop="styles" label="Style#" min-width="102">
          <template slot-scope="scope">
            <div v-if="!scope.row.styles || !scope.row.styles.length">-</div>
            <div v-else-if="scope.row.styles.length === 1">{{ scope.row.styles[0] }}</div>
            <el-tooltip v-else placement="bottom">
              <div slot="content">
                <div v-for="t in scope.row.styles" :key="t">{{ t }}</div>
              </div>
              <div>{{ scope.row.styles[0] }}...</div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="imageUrls" label="Image" min-width="120">
          <template slot-scope="scope">
            <ImageBanner ref="imageBanner" :imgList="scope.row.imageUrls" />
          </template>
        </el-table-column>

        <el-table-column prop="materials" label="Fabrication" min-width="160">
          <template slot-scope="scope">
            <div v-if="!scope.row.materials || !scope.row.materials.length">-</div>
            <div v-else-if="scope.row.materials.length === 1">{{ scope.row.materials[0] }}</div>
            <el-tooltip v-else placement="bottom">
              <div slot="content">
                <div v-for="t in scope.row.materials" :key="t">{{ t }}</div>
              </div>
              <div>{{ scope.row.materials[0] }}...</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="categories" label="Categories" min-width="120">
          <template slot-scope="scope">
            <div v-if="!scope.row.categories || !scope.row.categories.length">-</div>
            <div v-else-if="scope.row.categories.length === 1">{{ scope.row.categories[0] }}</div>
            <el-tooltip v-else placement="bottom">
              <div slot="content">
                <div v-for="t in scope.row.categories" :key="t">{{ t }}</div>
              </div>
              <div>{{ scope.row.categories[0] }}...</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="brands" label="Brand" min-width="100">
          <template slot-scope="scope">
            <div v-if="!scope.row.brands || !scope.row.brands.length">-</div>
            <div v-else-if="scope.row.brands.length === 1">{{ scope.row.brands[0] }}</div>
            <el-tooltip v-else placement="bottom">
              <div slot="content">
                <div v-for="t in scope.row.brands" :key="t">{{ t }}</div>
              </div>
              <div>{{ scope.row.brands[0] }}...</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="originalAmount" label="Original Amount" min-width="124">
          <template slot-scope="scope">
            <div>{{ scope.row.originalAmount || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="qty" label="Qty" min-width="90">
          <template slot-scope="scope">
            <div>{{ scope.row.qty || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" label="Unit Price" min-width="90">
          <template slot-scope="scope">
            <div>{{ scope.row.unitPrice || '-' }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="departureDates" label="Shipping Date" sortable="custom" width="140">
          <template slot-scope="scope">
            <template v-if="scope.row.departureDates.length">
              <div v-if="scope.row.departureDates.length === 1">{{ scope.row.departureDates[0].date | dateFormat }}/{{ scope.row.departureDates[0].num }}</div>
              <el-tooltip v-else placement="bottom">
                <div slot="content">
                  <div v-for="t in scope.row.departureDates" :key="t.date">{{ t.date | dateFormat }}/{{ t.num }}</div>
                </div>
                <div>{{ scope.row.departureDates[0].date | dateFormat }}/{{ scope.row.departureDates[0].num }}...</div>
              </el-tooltip>
            </template>
            <template v-else-if="scope.row.estDepartureDates && scope.row.estDepartureDates.length">
              <div v-if="scope.row.estDepartureDates.length === 1">EST.{{ scope.row.estDepartureDates[0] | dateFormat }}</div>
              <el-tooltip v-else placement="bottom">
                <div slot="content">
                  <div v-for="t in scope.row.estDepartureDates" :key="t">EST.{{ t | dateFormat }}</div>
                </div>
                <div>EST.{{ scope.row.estDepartureDates[0] | dateFormat }}...</div>
              </el-tooltip>
            </template>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalDates" label="Date of Arrival" sortable="custom" width="140">
          <template slot-scope="scope">
            <template v-if="scope.row.arrivalDates.length">
              <div v-if="scope.row.arrivalDates.length === 1">{{ scope.row.arrivalDates[0].date | dateFormat }}/{{ scope.row.arrivalDates[0].num }}</div>
              <el-tooltip v-else placement="bottom">
                <div slot="content">
                  <div v-for="t in scope.row.arrivalDates" :key="t.date">{{ t.date | dateFormat }}/{{ t.num }}</div>
                </div>
                <div>{{ scope.row.arrivalDates[0].date | dateFormat }}/{{ scope.row.arrivalDates[0].num }}...</div>
              </el-tooltip>
            </template>
            <template v-else-if="scope.row.estArrivalDates && scope.row.estArrivalDates.length">
              <div v-if="scope.row.estArrivalDates.length === 1">EST.{{ scope.row.estArrivalDates[0] | dateFormat }}</div>
              <el-tooltip v-else placement="bottom">
                <div slot="content">
                  <div v-for="t in scope.row.estArrivalDates" :key="t">EST.{{ t | dateFormat }}</div>
                </div>
                <div>EST.{{ scope.row.estArrivalDates[0] | dateFormat }}...</div>
              </el-tooltip>
            </template>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="poStartDate" label="Start Date" sortable="custom" width="114">
          <template slot-scope="scope">
            {{ scope.row.poStartDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="poEndDate" label="Cancel Date" sortable="custom" width="130">
          <template slot-scope="scope">
            {{ scope.row.poEndDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="pickupDates" label="Pick up Date" sortable="custom" width="130">
          <template slot-scope="scope">
            <div v-if="!scope.row.pickupDates || !scope.row.pickupDates.length">-</div>
            <div v-else-if="scope.row.pickupDates.length === 1">{{ scope.row.pickupDates[0] | dateFormat }}</div>
            <el-tooltip v-else placement="bottom">
              <div slot="content">
                <div v-for="t in scope.row.pickupDates" :key="t">{{ t | dateFormat }}</div>
              </div>
              <div>{{ scope.row.pickupDates[0] | dateFormat }}...</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="paymentDates" label="Payment Date" sortable="custom" width="140">
          <template slot-scope="scope">
            <div v-if="!scope.row.paymentDates || !scope.row.paymentDates.length">-</div>
            <div v-else-if="scope.row.paymentDates.length === 1">{{ scope.row.paymentDates[0] | dateFormat }}</div>
            <el-tooltip v-else placement="bottom">
              <div slot="content">
                <div v-for="t in scope.row.paymentDates" :key="t">{{ t | dateFormat }}</div>
              </div>
              <div>{{ scope.row.paymentDates[0] | dateFormat }}...</div>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
      <div style="text-align:right;margin-top:10px" class="bg-white">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 200]"
          :total="total"
          :current-page.sync="filters.pageNumber"
          :page-size="filters.pageSize"
          @current-change="pageCurrentChange"
          @size-change="pageSizeChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import dayjs from 'dayjs'
// import moment from 'moment'
import ImageBanner from './components/ImageBanner.vue'
import CustomerTreeSelect from './components/CustomerTreeSelect.vue'

export default {
  components: { ImageBanner, CustomerTreeSelect },
  props: {
  },
  data() {
    return {
      filters: {
        searchContent: '',
        categoryList: [],
        brands: [],
        departmentIds: [],
        pageSize: 50,
        pageNumber: 1,
        searchType: 1,
        dateArray: []
      },
      brandList: [], // 公司列表
      categoryList: [], // 类别列表
      list: [],
      total: 0,
      multipleSelection: [],
      dateOptions: [
        { value: 1, label: 'Order Date' },
        { value: 2, label: 'Start Date' },
        { value: 3, label: 'Pick up Date' },
        { value: 4, label: 'Payment Date' }
      ],
      dateTime: []
    }
  },
  filters: {
    dateFormat(value) {
      return value ? dayjs(value).format('YYYY-MM-DD') : ''
    }
  },
  created() {
    this.getKeyCustomerOrders()
    this.getOrderPermissionData(2)
    this.getOrderPermissionData(4)
  },
  methods: {
    getKeyCustomerOrders() {
      let filters = _.cloneDeep(this.filters)
      if (!filters.attributeStatus || !filters.attributeStatus.length) {
        filters.attributeStatus = this.attributeStatusList
      }
      API.getKeyCustomerOrders(filters).then(res => {
        if (res.code !== 10000) {
          return this.$message.warning(res.message)
        }
        this.list = res.data.list
        this.total = res.data.total
        this.$nextTick(() => {
          this.$refs.tableData.doLayout()
        })
      })
    },
    handleSearchInput() {
      this.filters.pageNumber = 1 // 更改搜索内容时重置页码为第一页
      this.getKeyCustomerOrders()
    },
    handleDepartmentTreeChange(departmentIds) {
      this.filters.departmentIds = departmentIds
      this.handleSearchInput()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    pageSizeChange(pageSize) {
      this.filters.pageSize = pageSize
      this.getKeyCustomerOrders()
    },
    pageCurrentChange(page) {
      this.filters.pageNumber = page
      this.getKeyCustomerOrders()
    },
    /**
     * 当表格的排序条件发生变化的时候会触发该事件
     *
     * @param {Object} value 排序对象
     */
    onTableSortChange({ prop, order }) {
      if (order) {
        this.filters.sortType = prop
        this.filters.sort = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined
      } else {
        this.filters.sortType = undefined
        this.filters.sort = undefined
      }
      this.getKeyCustomerOrders()
    },
    getOrderPermissionData(searchType) {
      // 调用接口获取下拉筛选选项（客户名称/品牌/类别）
      API.getOrderPermissionData({ searchType }).then(res => {
        if (res.code !== 10000) return this.$message.warning(res.message)
        if (searchType === 2) this.brandList = res.data
        else if (searchType === 4) this.categoryList = res.data
      })
    },
    // headerCellStyle({ row, column, rowIndex, columnIndex }) {
    //   if (!this.shipped && column.property === 'applicationDate') {
    //     if (this.filters.sortType === 'applicationDate') {
    //       column.order = this.filters.sort === 'desc' ? 'descending' : this.filters.sort === 'asc' ? 'ascending' : ''
    //     } else {
    //       column.order = ''
    //     }
    //   }
    //   if (!this.filters.sortType) column.order = ''
    // }

    changeDateType() {
      if (this.dateTime.length === 2) {
        this.filters.dateArray = this.dateTime
        this.handleSearchInput()
      }
    },
    changeDatePicker(date) {
      this.filters.dateArray = date || []
      this.handleSearchInput()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 15px;
  padding-bottom: 4px;
  .title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
  }
}

.custom-order-content {
  background-color: #fff;
  padding: 16px 16px 10px 16px;
  .filters {
    margin-bottom: 2px;
    flex-wrap: wrap;
    >div {
      margin-right: 10px;
      margin-bottom: 6px;
    }
    /deep/ .el-input__inner {
      border-radius: unset;
    }
    /deep/ .el-select__tags .el-tag {
      max-width: 96px !important;
    }
  }
  .table {
    /deep/ .el-popover__reference-wrapper{
      img {
        width: 48px;
        height: 64px;
      }
    }
    /deep/ .cell {
      word-break: break-word;
    }
  }
}
</style>
